SupportBasePresentation = require('./base')
SupportLiveStatusAndNotesPresentation = require('./live_messages')

class SupportLivePresenterPresentation extends SupportBasePresentation
	getLookupObject: () ->
		SupportLiveStatusAndNotesPresentation

module.exports = SupportLivePresenterPresentation

